export const Country = {
    EE: 'EE',
    LV: 'LV'
};